/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  box-sizing: border-box;
  contain: content;
  display: grid;
  min-height: 100%;
  height: 100%;
  padding-top: 1.5rem;
  padding-bottom: 1rem;
}
:host svg {
  height: 100%;
  width: 100%;
  justify-self: stretch;
  fill: #2C3133;
  fill: var(--davinci-color-text-on-background, #2C3133);
}
:host svg p {
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
:host svg #indicatorText {
  text-align: center;
  font-weight: 600;
}
:host svg #indicatorMinText {
  text-align: start;
  font-weight: 400;
}
:host svg #indicatorMaxText {
  text-align: end;
  font-weight: 400;
}
:host svg #trendText {
  font-weight: 600;
}

:host([hidden]) {
  display: none;
}

text {
  fill: #2C3133;
  fill: var(--davinci-color-text-on-background, #2C3133);
}

stroke {
  fill: #2C3133;
  fill: var(--davinci-color-text-on-background, #2C3133);
}`;
export { style };
